import { makeStyles } from 'tss-react/mui';

const useStylesPasswordStrengthBar: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  passwordStrengthBar: {
    marginTop: 2,
  },
  progressBarError: {
    backgroundColor: `${theme.palette.error.main} !important`,
  },
  progressBarErrorBackground: {
    backgroundColor: `${theme.palette.error.light} !important`,
  },
  progressBarNormal: {
    backgroundColor: `${theme.palette.warning.main} !important`,
  },
  progressBarNormalBackground: {
    backgroundColor: `${theme.palette.warning.light} !important`,
  },
  progressBarStrong: {
    backgroundColor: `${theme.palette.success.main} !important`,
  },
  progressBarStrongBackground: {
    backgroundColor: `${theme.palette.success.light} !important`,
  },
}));

export default useStylesPasswordStrengthBar;
